import { add, addDays, compareAsc, differenceInMinutes, set, sub } from 'date-fns'
import { START_WORKING_HOUR } from './constants'

export const isValidTime = (value) => {
	const regexp = /^\d{0,2}?:?\d{0,2}$/
	const [hoursStr, minutesStr] = value.split(':')

	if (!regexp.test(value)) {
		return false
	}

	const hours = Number(hoursStr)
	const minutes = Number(minutesStr)

	if (!isValidHoursOrMinutes(hours, 'hours') || !(isValidHoursOrMinutes(minutes, 'minutes') && hours >= 0 && hours < 24)) {
		return false
	}

	return true
}

export const isValidHoursOrMinutes = (value, type = '') => {
	const regexp = /^\d{0,2}$/

	if (!regexp.test(value)) {
		return false
	}

	if (type === 'hours') {
		const hours = Number(value)

		if (!(Number.isInteger(hours) && hours >= 0 && hours < 24)) {
			return false
		}

		return true
	} else {
		const minutes = Number(value)

		if (!(Number.isInteger(minutes) || Number.isNaN(minutes))) {
			return false
		}

		if (minutes && (parseInt(minutes, 10) < 0 || parseInt(minutes, 10) > 59)) {
			return false
		}

		return true
	}
}

export const handleHoursOrMinutesValidationOnBlur = (value) => {
	if (!value.length) value = '00'
	if (value.length === 1) value = '0' + value

	return value
}

export const handleTimeValidationOnBlur = (value) => {
	if (!value || value === ':') {
		return '00:00'
	}

	let [hoursStr, minutesStr] = value.split(':')
	hoursStr = handleHoursOrMinutesValidationOnBlur(hoursStr)
	minutesStr = handleHoursOrMinutesValidationOnBlur(minutesStr)

	return hoursStr + ':' + minutesStr
}

const checkTimeIsStartWorkingHours = (time) => {
	const [hours, minutes] = time.split(':')
	return +hours === START_WORKING_HOUR && +minutes === 0
}

export const checkPeriodCloseTimeExactOpenTime = (periods) => {
	const openingHours = periods[0].openingTime
	const openTimeIsDateStart = checkTimeIsStartWorkingHours(openingHours)
	const closingHours = periods.length > 1 ? periods[1].closingTime : periods[0].closingTime
	const closeTimeIsDateEnd = checkTimeIsStartWorkingHours(closingHours)
	return openTimeIsDateStart && closeTimeIsDateEnd
}

const convertTimeToDateFormat = (item, closeTimeExactOpenTime = false) => {
	const today = new Date()
	const [hours, minutes] = item.split(':')
	const isTommorow = +hours < START_WORKING_HOUR || closeTimeExactOpenTime
	const date = isTommorow ? addDays(today, 1) : today
	return set(date, { hours, minutes, seconds: 0 })
}

const checkIsValidCompareTime = (firstDate, secondDate) => {
	if (compareAsc(firstDate, secondDate) === -1) return true // is valid - first date is before the second
	return false
}

export const isValidTimePeriodsOrder = (periods, minDifferenceTime = 1, delayAfterOpen = { hours: 0, minutes: 0 }, delayBeforeClose = { hours: 0, minutes: 0 }) => {
	const today = new Date()
	const tommorow = addDays(today, 1)
	const controlDateStart = set(today, { hours: START_WORKING_HOUR - 1, minutes: 59, seconds: 59 })
	const controlDateEnd = set(tommorow, { hours: START_WORKING_HOUR, minutes: 0, seconds: 1 })
	const periodCloseTimeExactOpenTime = checkPeriodCloseTimeExactOpenTime(periods)

	const openingHoursBeforeBreak = periods[0].openingTime
	const closingHoursBeforeBreak = periods[0].closingTime
	const convertedOpeningHoursBeforeBreak = convertTimeToDateFormat(openingHoursBeforeBreak)
	const watchClosingHoursBeforeBreakIsExactOpenTime = periods.length > 1 ? false : periodCloseTimeExactOpenTime
	const convertedClosingHoursBeforeBreak = convertTimeToDateFormat(closingHoursBeforeBreak, watchClosingHoursBeforeBreakIsExactOpenTime)
	const openingHoursBeforeBreakWithPreorderDelay = add(convertedOpeningHoursBeforeBreak, delayAfterOpen)
	const closingHoursBeforeBreakWithPreorderDelay = sub(convertedClosingHoursBeforeBreak, delayBeforeClose)
	const isValidMinWorkingTimeBeforeBreak = differenceInMinutes(closingHoursBeforeBreakWithPreorderDelay, openingHoursBeforeBreakWithPreorderDelay) >= minDifferenceTime

	if (periods.length > 1) {
		const openingHoursAfterBreak = periods[1].openingTime
		const closingHoursAfterBreak = periods[1].closingTime
		const convertedOpeningHoursAfterBreak = convertTimeToDateFormat(openingHoursAfterBreak)
		const convertedClosingHoursAfterBreak = convertTimeToDateFormat(closingHoursAfterBreak, periodCloseTimeExactOpenTime)
		const openingHoursAfterBreakWithPreorderDelay = add(convertedOpeningHoursAfterBreak, delayAfterOpen)
		const closingHoursAfterBreakWithPreorderDelay = sub(convertedClosingHoursAfterBreak, delayBeforeClose)
		const isValidMinWorkingTimeAfterBreak = differenceInMinutes(closingHoursAfterBreakWithPreorderDelay, openingHoursAfterBreakWithPreorderDelay) >= minDifferenceTime

		return checkIsValidCompareTime(controlDateStart, convertedOpeningHoursBeforeBreak)
			&& checkIsValidCompareTime(convertedOpeningHoursBeforeBreak, controlDateEnd)
			&& checkIsValidCompareTime(convertedOpeningHoursAfterBreak, controlDateEnd)
			&& checkIsValidCompareTime(convertedClosingHoursBeforeBreak, convertedOpeningHoursAfterBreak)
			&& isValidMinWorkingTimeBeforeBreak && isValidMinWorkingTimeAfterBreak
	} else {
		return checkIsValidCompareTime(controlDateStart, convertedOpeningHoursBeforeBreak)
			&& checkIsValidCompareTime(convertedClosingHoursBeforeBreak, controlDateEnd)
			&& isValidMinWorkingTimeBeforeBreak
	}
}
